<template>
    <div class="bg p-3 pb-6">
        <vss-select
            ref="modeloSelect"
            title="modelo"
            v-model="modeloSelected"
            :options="modelosJasperList"
            :loading="modeloLoading"
            @search="findAllJasperAtendimentoPromotor"
            searchable
            clearable
            required
            :disabled="isModeloNotConfigured"
            :invalid="isNull(modeloSelected)"
            placeholder="selecione-uma-opcao"
        />
        <v-textarea v-if="isModeloNotConfigured"
            :value="$t('aviso-sem-jasper-cadastrado')"
            title="descricao-do-modelo"
            :rows="6"
            :maxRows="6"
            disableTransform
            disabled
        />
        <v-textarea v-else
            v-model="modeloSelectedObservacao"
            title="descricao-do-modelo"
            :rows="6"
            :maxRows="6"
            disableTransform
            disabled
        />
        <p v-if="!isModeloNotConfigured" class="mt-2 is-text-color-danger is-text-center is-bold">{{ $t('atencao-exportacao-de-dados') }}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            modelosJasperList: [],
            modeloSelected: null,
            modeloLoading: false,
            isSeaching: false,
        }
    },
    computed: {
        isModeloNotConfigured: function () {
            return !this.isSeaching && this.modelosJasperList.length === 0
        },
        modeloSelectedObservacao: function () {
            return this.modeloSelected ? this.modeloSelected.observacao : '';
        }
    },
    watch: {
        modeloSelected(newModeloSelected) {
            this.$emit('updateModeloSelected', newModeloSelected);
        }
    },
    methods: {
        async findAllJasperAtendimentoPromotor(searchQuery) {
            try {
                this.modeloLoading = true;

                const response = await this.$axios
                .get(`/conf-jasper/findAll?origem=ATENDIMENTO_PROMOTOR&search=${searchQuery}`)

                const mappedModelos = this.mapModelosToSelect(response.data.content);

                this.modelosJasperList = mappedModelos;
            } catch (e) {
                this.$root.showMessage('error', 'erro-exportar-atendimentos')
            } finally {
                this.modeloLoading = false;
            }
        },
        mapModelosToSelect(modelos) {
            return modelos.map(({idconfjasper, titulo, texto}) => ({
                id: idconfjasper,
                label: titulo,
                observacao: texto
            }))
        },
        carregaModelos(searchQuery) {
            this.isSeaching = Boolean(searchQuery);
        }
    }
}
</script>

<style  lang="scss" scoped>
.is-text-center {
    text-align: center;
}
</style>